function createEventDetails(event) {
  var eventAttr = event.Actor.Attributes;
  var details = '';

  var action = event.Action;
  var extra = '';
  var hasColon = action.indexOf(':');
  if (hasColon != -1) {
    extra = action.substring(hasColon);
    action = action.substring(0, hasColon);
  }

  switch (event.Type) {
    case 'container':
      switch (action) {
        case 'stop':
          details = 'Контейнер ' + eventAttr.name + ' остановлен';
          break;
        case 'destroy':
          details = 'Контейнер ' + eventAttr.name + ' удалён';
          break;
        case 'create':
          details = 'Контейнер ' + eventAttr.name + ' создан';
          break;
        case 'start':
          details = 'Контейнер ' + eventAttr.name + ' запущен';
          break;
        case 'kill':
          details = 'Контейнер ' + eventAttr.name + ' принудительно завершён';
          break;
        case 'die':
          details = 'Контейнер ' + eventAttr.name + ' завершился с кодом ' + eventAttr.exitCode;
          break;
        case 'commit':
          details = 'Контейнер ' + eventAttr.name + ' зафиксирован в образ';
          break;
        case 'restart':
          details = 'Контейнер ' + eventAttr.name + ' перезапущен';
          break;
        case 'pause':
          details = 'Контейнер ' + eventAttr.name + ' приостановлен';
          break;
        case 'unpause':
          details = 'Работа контейнера ' + eventAttr.name + ' возобновлена';
          break;
        case 'attach':
          details = 'Выполнено подключение к контейнеру ' + eventAttr.name;
          break;
        case 'detach':
          details = 'Выполнено отключение от контейнера ' + eventAttr.name;
          break;
        case 'copy':
          details = 'Данные контейнера ' + eventAttr.name + ' скопированы';
          break;
        case 'export':
          details = 'Контейнер ' + eventAttr.name + ' экспортирован';
          break;
        case 'health_status':
          details = 'Контейнер ' + eventAttr.name + ': выполнена проверка работоспособности';
          break;
        case 'oom':
          details = 'Контейнеру ' + eventAttr.name + ' не хватило памяти';
          break;
        case 'rename':
          details = 'Контейнер ' + eventAttr.name + ' переименован';
          break;
        case 'resize':
          details = 'Изменён размер терминала контейнера ' + eventAttr.name;
          break;
        case 'top':
          details = 'Показаны запущенные процессы контейнера ' + eventAttr.name;
          break;
        case 'update':
          details = 'Контейнер ' + eventAttr.name + ' обновлён';
          break;
        case 'exec_create':
          details = 'Создан сеанс exec';
          break;
        case 'exec_start':
          details = 'Запущен сеанс exec';
          break;
        case 'exec_die':
          details = 'Сеанс exec завершён';
          break;
        default:
          details = 'Неподдерживаемое событие';
      }
      break;
    case 'image':
      switch (action) {
        case 'delete':
          details = 'Образ удалён';
          break;
        case 'import':
          details = 'Образ ' + event.Actor.ID + ' импортирован';
          break;
        case 'load':
          details = 'Образ ' + event.Actor.ID + ' загружен из архива';
          break;
        case 'tag':
          details = 'Создан новый тег для ' + eventAttr.name;
          break;
        case 'untag':
          details = 'Тег образа удалён';
          break;
        case 'save':
          details = 'Образ ' + event.Actor.ID + ' сохранён';
          break;
        case 'pull':
          details = 'Образ ' + event.Actor.ID + ' получен из реестра';
          break;
        case 'push':
          details = 'Образ ' + event.Actor.ID + ' отправлен в реестр';
          break;
        default:
          details = 'Неподдерживаемое событие';
      }
      break;
    case 'network':
      switch (action) {
        case 'create':
          details = 'Сеть ' + eventAttr.name + ' создана';
          break;
        case 'destroy':
          details = 'Сеть ' + eventAttr.name + ' удалена';
          break;
        case 'remove':
          details = 'Сеть ' + eventAttr.name + ' удалена';
          break;
        case 'connect':
          details = 'Контейнер подключён к сети ' + eventAttr.name;
          break;
        case 'disconnect':
          details = 'Контейнер отключён от сети ' + eventAttr.name;
          break;
        default:
          details = 'Неподдерживаемое событие';
      }
      break;
    case 'volume':
      switch (action) {
        case 'create':
          details = 'Том ' + event.Actor.ID + ' создан';
          break;
        case 'destroy':
          details = 'Том ' + event.Actor.ID + ' удалён';
          break;
        case 'mount':
          details = 'Том ' + event.Actor.ID + ' подключён';
          break;
        case 'unmount':
          details = 'Том ' + event.Actor.ID + ' отключён';
          break;
        default:
          details = 'Неподдерживаемое событие';
      }
      break;
    default:
      details = 'Неподдерживаемое событие';
  }
  return details + extra;
}

export function EventViewModel(data) {
  // Type, Action, Actor unavailable in Docker < 1.10
  this.Time = data.time;
  if (data.Type) {
    this.Type = data.Type;
    this.Details = createEventDetails(data);
  } else {
    this.Type = data.status;
    this.Details = data.from;
  }
}
